import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import IconTrash from 'approot/shared/icons/icon-trash';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { NegativeButton } from 'approot/shared/styles/buttons';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { PStyled } from 'approot/shared/styles/typography.style';

type Props = {
  loading: boolean;
  onDelete: (onCompleted?: () => void) => void;
};

const InteractiveResponseDeleteItem = ({ loading, onDelete }: Props) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  return (
    <>
      {isVisible && (
        <ActivityBuilderModal
          isVisible
          title="Delete item"
          headerTitle="Delete item"
          onClose={closeModal}
          actions={
            <NegativeButton
              type="button"
              loading={loading}
              disabled={loading}
              onClick={() => {
                onDelete(closeModal);
              }}
            >
              Delete
            </NegativeButton>
          }
        >
          <PStyled>Are you sure you want to delete this item?</PStyled>
        </ActivityBuilderModal>
      )}
      <SecondaryButtonIcon type="button" $isSmall onClick={openModal}>
        <IconTrash width={20} height={20} />
      </SecondaryButtonIcon>
    </>
  );
};

export default InteractiveResponseDeleteItem;
